export const localObjectStorage = {
  store(key, obj) {
    localStorage.setItem(key, JSON.stringify(obj));
  },
  load(key) {
    const storedValue = localStorage.getItem(key);
    if (!storedValue) {
      return null;
    }

    try {
      return JSON.parse(storedValue);
    } catch (e) {
      console.error(e); // eslint-disable-line no-console
      return null;
    }
  },
  remove(key) {
    localStorage.removeItem(key);
  },
};
